import {
  darken,
  lighten,
  makeStyles,
  withStyles,
} from "@material-ui/core/styles";
import { find as _find, get as _get } from "lodash";
import React from "react";

import {
  Box,
  Button,
  Divider,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ClearIcon from "@material-ui/icons/Clear";
import DoneIcon from "@material-ui/icons/Done";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import EmailIcon from "@material-ui/icons/EmailOutlined";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import { useTranslation } from "react-i18next";
import { connect, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { resetContract } from "../../helpers/services/ContractServices";
import {
  retrieveCompanySubsidiaries,
  retrieveContract,
  retrieveContractAppendices,
} from "../../redux/contract/contract.actions";
import {
  brand_details,
  selectedContract,
  selectIsSelectedContractDetailsFetching,
} from "../../redux/contract/contract.selector";
import BrandAppendix from "../BrandAppendix/BrandAppendix.component";
import DomainList from "../DomainList";
import TicketList from "../TicketList/TicketList";
import "./ContractDetails.css";

const useStyles = makeStyles((theme) => ({
  header: {
    background: theme.palette.grey[200],
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(0, 2),
    gap: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    display: "grid",
    gap: theme.spacing(2),
  },
  back_btn: {
    display: "flex",
    justifyContent: "flex-end",
  },
  resetContractButton: {
    backgroundColor: "orangered",
    color: "#ffffff",
  },
  detailSectionPane: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    padding: theme.spacing(2),
  },
  detailSection: {
    display: "grid",
    gap: theme.spacing(2),
  },
  detailItem: {
    display: "flex",
    gap: theme.spacing(1),
  },
  mail: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  tabLogos: {
    height: 32,
  },
}));

function TabPanel(props) {
  const { children, value, indices, ...other } = props;

  return (
    <div
      component="div"
      role="tabpanel"
      hidden={!indices.includes(value)}
      {...other}
    >
      {indices.includes(value) && <Box>{children}</Box>}
    </div>
  );
}

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#245144",
    "& > div": {
      width: 0,
      height: 0,
      borderLeft: "5px solid transparent",
      borderRight: "5px solid transparent",
      borderBottom: "7px solid #245144",
      top: -7,
      position: "absolute",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

const ContractDetails = function ({
  retrieveCompanySubsidiaries,
  retrieveCompanyAddresses,
  retrieveContractAppendices,
  retrieveContract,
}) {
  // const selectedContract = useSelector(
  //   (state) => state.contract.contractsList.find()
  // );
  const selectedContract = useSelector(
    (state) => state.contract?.selectedContract
  );
  const brand_details = useSelector((state) => state.contract.brand_details);
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const user = useSelector((state) => state.user);
  let brands = brand_details;
  let associatedBrands = selectedContract.brands.map((v) => v.brand_name);
  console.log(associatedBrands);
  const [tabValue, setTabValue] = React.useState(
    _get(associatedBrands, "0") || "subsidiaries"
  );
  // const [contractDetail, setContractDetail] = React.useState(selectedContract);
  const [selectedBrandAppendix, setSelectedBrandAppendix] = React.useState({});
  const [dataRefreshSwitch, setDataRefreshSwitch] = React.useState(false);
  console.log("selectedContract", selectedContract);

  const getStatusDisplayValue = (status) => {
    let _o = "";
    switch (status) {
      case "initial":
        _o = `${t("flokk_appendix.status.options.initial")}`;
        break;
      case "negotiated":
        _o = `${t("flokk_appendix.status.options.negotiated")}`;
        break;
      case "confirmed":
        _o = `${t("flokk_appendix.status.options.confirmed")}`;
        break;
      case "abgelehnt":
        _o = "Verhandeln";
        break;

      case "negotiating":
        _o = `${t("flokk_contractappendix.status.options.negotiating")}`;
        break;
      case "awaiting_client_sig":
        _o = `${t(
          "flokk_contractappendix.status.options.awaiting_client_sig"
        )}`;
        break;
      case "closed":
        _o = `${t("flokk_contractappendix.status.options.closed")}`;
        break;
      default:
        break;
    }
    return _o;
  };
  console.log("associatedBrands", associatedBrands);
  const handleTabChange = (event, newValue) => {
    console.log("newValue", newValue);
    // brands.map((b) => {
    if (associatedBrands.includes(newValue)) {
      setSelectedBrandAppendix(
        _find(selectedContract.appendices, { brand_id_short_name: newValue })
      );
    }
    // });

    setTabValue(newValue);
  };
  React.useEffect(() => {
    retrieveCompanySubsidiaries(selectedContract.trader_company_id);
    // retrieveCompanyAddresses(selectedContract.trader_company_id);
    retrieveContractAppendices(selectedContract.contract_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (dataRefreshSwitch) {
      retrieveContractAppendices(selectedContract.contract_id);
      // setDataRefreshSwitch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataRefreshSwitch]);

  const switchDataRefreshOn = () => {
    setDataRefreshSwitch(true);
  };

  React.useEffect(() => {
    //setContractDetail(selectedContract);
    if (!dataRefreshSwitch) {
      let _tabValue = _get(
        _find(selectedContract.brands, (b) => {
          return (
            b.saleslead_id === user.currentUser.id ||
            b.teamlead_id === user.currentUser.id
          );
        }),
        "brand_name"
      );
      handleTabChange({}, _tabValue || "subsidiaries");
    } else {
      handleTabChange({}, tabValue);
      setDataRefreshSwitch(false);
    }
    //associatedBrands[0] ||
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedContract]);

  console.log(
    "RH LOGO",
    _get(
      _find(brands, (b) => {
        return b.name === "rh";
      }),
      "logo.url"
    )
  );
  const handleResetContract = async () => {
    try {
      let result = await resetContract(selectedContract.contract_id);
      // retrieveContract(selectedContract.contract_id);
      setDataRefreshSwitch(true);
    } catch (error) {
      console.log(error);
    }
  };
  const handleBackButton = () => {
    history.push("/contracts");
  };
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography color="primary" variant="h6">
          {selectedContract.trader_name}
          {" - "}
          {selectedContract.name === "contract_main" &&
            t("flokk_contractappendix.name.options.contract_main") +
              " - " +
              selectedContract.year}
          {selectedContract.name === "contract_ext" &&
            t("flokk_contractappendix.name.options.contract_ext") +
              " - " +
              selectedContract.year}
        </Typography>

        <div className={classes.contractStatus}>
          <Typography color="primary" variant="subtitle2">
            {t("flokk_contract.contract_status")}
          </Typography>
          <Typography variant="caption">
            {getStatusDisplayValue(selectedContract.status)}
          </Typography>
        </div>

        {selectedContract.status === "awaiting_client_sig" && (
          <Button
            className={classes.resetContractButton}
            variant="contained"
            onClick={handleResetContract}
          >
            {t("buttons.resetcontract")}
          </Button>
        )}
      </div>

      <Paper square className={classes.detailSectionPane}>
        <div className={classes.detailSection}>
          <div className={classes.detailItem}>
            <Typography>
              {t("flokk_contract.trader_contact_location_id")}:
            </Typography>
            <Typography>
              {_get(
                _find(selectedContract.addresses, { address_type: "Legal" }),
                "street"
              )}{" "}
              {_get(
                _find(selectedContract.addresses, { address_type: "Legal" }),
                "house_no"
              )}{" "}
              {_get(
                _find(selectedContract.addresses, { address_type: "Legal" }),
                "zip_code"
              )}{" "}
              {_get(
                _find(selectedContract.addresses, { address_type: "Legal" }),
                "city"
              )}
              {selectedContract.trader_contact_location_id_short_name}
            </Typography>
          </div>
          <div className={classes.detailItem}>
            <Typography>{t("flokk_contractappendix.customer_no")}:</Typography>
            <Typography>{selectedContract.customer_no}</Typography>
          </div>
        </div>

        <div className={classes.detailSection}>
          <div className={classes.detailItem} style={{ justifyContent: "end" }}>
            <Typography>
              {t("flokk_contractappendix.main_sales_person_id")}:
            </Typography>
            <Typography>
              {selectedContract.main_sales_person_first_name +
                " " +
                selectedContract.main_sales_person_last_name}
            </Typography>
            <a href={"mailto:" + selectedContract.main_sales_person_email}>
              <EmailIcon color="primary" fontSize="small" />
            </a>
          </div>
        </div>
      </Paper>

      <Paper square className={classes.content}>
        <div className={classes.back_btn}>
          <Button
            startIcon={<ArrowBackIosIcon />}
            color="primary"
            variant="contained"
            onClick={handleBackButton}
          >
            {t("flokk_contract.back_to_list")}
          </Button>
        </div>

        <div style={{ display: "grid" }}>
          <StyledTabs
            indicatorColor="primary"
            value={tabValue || ""}
            onChange={handleTabChange}
            variant="scrollable"
          >
            <Tab
              className={classes.tab}
              label={t("links.flokk_companylocation")}
              color="secondary"
              wrapped
              value="subsidiaries"
            />

            <Tab
              className={classes.tab}
              style={{
                backgroundColor: lighten(selectedContract.tickets_color, 0.5),
                color: darken(selectedContract.tickets_color, 0.5),
              }}
              label={t("links.flokk_tickets")}
              color="secondary"
              wrapped
              value="tickets"
            />

            {associatedBrands?.map((a) => {
              return (
                <Tab
                  key={a}
                  className={classes.tab}
                  icon={
                    <img
                      alt="unknown"
                      src={_get(
                        _find(brands, (b) => {
                          return b.name === a;
                        }),
                        "logo.url"
                      )}
                      className={classes.tabLogos}
                    />
                  }
                  value={
                    _get(
                      _find(selectedContract.brands, (b) => {
                        return (
                          b.brand_name === a &&
                          (selectedContract.main_sales_person_id ===
                            user.currentUser.id ||
                            b.teamlead_id === user.currentUser.id ||
                            b.saleslead_id === user.currentUser.id)
                        );
                      }),
                      "brand_name"
                    ) || ""
                  }
                  disabled={
                    !_get(
                      _find(selectedContract.brands, (b) => {
                        return (
                          b.brand_name === a &&
                          (selectedContract.main_sales_person_id ===
                            user.currentUser.id ||
                            b.teamlead_id === user.currentUser.id ||
                            b.saleslead_id === user.currentUser.id)
                        );
                      }),
                      "brand_name"
                    )
                  }
                />
              );
            })}

            <Tab
              className={classes.tab}
              color="secondary"
              label={t("links.flokk_onlinedomain")}
              value="domain"
            />
          </StyledTabs>
          <Divider />
        </div>

        <TabPanel value={tabValue} indices={["subsidiaries"]}>
          <Table style={{ backgroundColor: "#ffffff" }} size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography
                    variant="overline"
                    style={{ color: "#1a202c", fontWeight: "bold" }}
                  >
                    {t("location.company_id")}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    variant="overline"
                    style={{ color: "#1a202c", fontWeight: "bold" }}
                  >
                    {t("flokk_location.street")}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    variant="overline"
                    style={{ color: "#1a202c", fontWeight: "bold" }}
                  >
                    {t("flokk_location.zip_code")}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    variant="overline"
                    style={{ color: "#1a202c", fontWeight: "bold" }}
                  >
                    {t("flokk_location.city")}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    variant="overline"
                    style={{ color: "#1a202c", fontWeight: "bold" }}
                  >
                    {t("flokk_location.country")}
                  </Typography>
                </TableCell>
                {/*} <TableCell style={{textAlign : "center"}}><Typography
              variant="overline"
        style={{ color: "#1a202c", textAlign : "center" }}>Aktion</Typography></TableCell>*/}
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedContract.subsidiaries &&
                selectedContract.subsidiaries.length > 0 &&
                selectedContract.subsidiaries.map((subsidiary) => (
                  <TableRow key={subsidiary.id}>
                    <TableCell>{subsidiary.name}</TableCell>
                    <TableCell>
                      {subsidiary.street + ", " + subsidiary.house_no}
                    </TableCell>
                    <TableCell>{subsidiary.zip_code}</TableCell>
                    <TableCell>{subsidiary.city}</TableCell>
                    <TableCell>{subsidiary.country_id_short_name}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          {/*<Button style={{marginTop : "1rem"}}  color="secondary" variant="contained">Neu Tochterfirma</Button>*/}
        </TabPanel>

        <TabPanel value={tabValue} indices={["tickets"]}>
          <TicketList
            trader_company_id={selectedContract.trader_company_id}
            count={+selectedContract.tickets_count}
          />
        </TabPanel>

        <TabPanel value={tabValue} indices={["domain"]}>
          <DomainList
            trader_company_id={selectedContract.trader_company_id}
            status={selectedContract.status}
          />
        </TabPanel>

        <TabPanel value={tabValue} indices={["addresses"]}>
          <Table style={{ backgroundColor: "#ffffff" }} size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography variant="overline" style={{ color: "#1a202c" }}>
                    Typ
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="overline" style={{ color: "#1a202c" }}>
                    Straße
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="overline" style={{ color: "#1a202c" }}>
                    PLZ
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="overline" style={{ color: "#1a202c" }}>
                    Ort
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="overline" style={{ color: "#1a202c" }}>
                    Land
                  </Typography>
                </TableCell>
                <TableCell style={{ textAlign: "center" }}>
                  <Typography variant="overline" style={{ color: "#1a202c" }}>
                    Aktion
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedContract.addresses &&
                selectedContract.addresses.length > 0 &&
                selectedContract.addresses.map((address) => (
                  <TableRow key={address.id}>
                    <TableCell>{address.address_type}</TableCell>
                    <TableCell>
                      {address.street + ", " + address.house_no}
                    </TableCell>
                    <TableCell>{address.zip_code}</TableCell>
                    <TableCell>{address.city}</TableCell>
                    <TableCell>{address.country}</TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      <Button color="secondary">
                        <EditOutlinedIcon />
                      </Button>
                      <Button color="secondary">
                        <ClearIcon />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <Button
            style={{ marginTop: "1rem" }}
            color="secondary"
            variant="contained"
          >
            Neu Adresse
          </Button>
        </TabPanel>

        <TabPanel
          value={tabValue}
          indices={selectedContract.brands.map((brand) => {
            if (
              brand.teamlead_id === user.currentUser.id ||
              brand.saleslead_id === user.currentUser.id ||
              selectedContract.main_sales_person_id === user.currentUser.id
            )
              return brand.brand_name;
            else return false;
          })}
        >
          {selectedBrandAppendix && (
            <BrandAppendix
              selectedBrandAppendix={selectedBrandAppendix}
              switchDataRefreshOn={switchDataRefreshOn}
              user={user}
            />
          )}
        </TabPanel>
      </Paper>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = (dispatch) => ({
  retrieveCompanySubsidiaries: (companyId) =>
    dispatch(retrieveCompanySubsidiaries(companyId)),
  // retrieveCompanyAddresses: (companyId) =>
  //   dispatch(retrieveCompanyAddresses(companyId)),
  retrieveContractAppendices: (contractId) =>
    dispatch(retrieveContractAppendices(contractId)),
  retrieveContract: (contractId) => dispatch(retrieveContract(contractId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContractDetails);
const getStatusIcon = (status) => {
  let iconComponent = <div></div>;
  switch (status) {
    case "INITIAL":
      iconComponent = <HourglassEmptyIcon />;
      break;
    case "Negotiating":
      iconComponent = <DoneIcon />;
      break;
    case "Rejected":
      iconComponent = <ClearIcon />;
      break;
    case "Confirmed":
      iconComponent = (
        <div>
          <DoneIcon />
          <DoneIcon />
        </div>
      );
      break;
    default:
      iconComponent = <HourglassEmptyIcon />;
  }
};
